import * as React from 'react';
import makeComp from '../../util/profiler';
import * as HL from './cg/hl';
import * as GraphNorm from './cg/graphNorm';
import * as GraphCyto from './graphCyto';

const cytoscape = require('cytoscape');
const dagre = require('cytoscape-dagre');
const CytoscapeComponent = require('react-cytoscapejs');

cytoscape.use(dagre);

let renderCount = 0;

export const ComputeGraphViz: React.FC<{
  node: HL.EditingNode;
  highlightNode?: HL.EditingNode;
  width: number;
  height: number;
}> = makeComp(
  props => {
    const {node, highlightNode, width, height} = props;

    // Note: this does EXPENSIVE OPERATIONS on every render cycle!
    // Don't use this component in production as is!
    const ng = GraphNorm.graphNorm(node);
    const cytoGraph = GraphCyto.normGraphToCyto(ng, highlightNode);
    // And we use renderCount as a key to force Cytoscape to rerender.
    renderCount++;

    return (
      <CytoscapeComponent
        key={renderCount}
        maxZoom={1.5}
        elements={cytoGraph}
        // If we set height to 100%, or try to use flex, the component starts
        // growing an infinite loop for some reason
        style={{width, height}}
        layout={{
          name: 'dagre',
          rankDir: 'LR',
          // rankSep: 10,
          spacingFactor: 0.7,
          nodeDimensionsIncludeLabels: true,
        }}
        stylesheet={[
          {
            selector: 'node[label]',
            style: {
              label: 'data(label)',
              'font-size': '12px',
              'text-wrap': 'ellipsis',
              'text-max-width': 300,
              'text-margin-y': -4,
            },
          },
          {
            selector: 'node',
            style: {
              color: '#363a3d',
              'background-color': 'white',
              'border-color': '#007faf',
              'border-width': 2,
              width: 20,
              height: 20,
            },
          },
          {
            selector: 'node.highlight',
            style: {
              'background-color': '#007faf',
            },
          },
          {
            selector: 'node.const',
            style: {
              shape: 'rectangle',
              width: 30,
              height: 10,
            },
          },
          {
            selector: 'node.var',
            style: {
              shape: 'diamond',
              width: 20,
              height: 20,
            },
          },
          {
            selector: 'node.void',
            style: {
              shape: 'triangle',
              width: 20,
              height: 20,
            },
          },
          {
            selector: 'edge[label]',
            style: {
              label: 'data(label)',
              color: '#888',
              'font-size': '12px',
              'text-wrap': 'ellipsis',
              'text-max-width': 300,
              'text-margin-y': 10,
            },
          },
          {
            selector: 'edge',
            style: {
              width: 2,
              'line-color': '#99ccdf',
              // opacity: 0.5,
              'curve-style': 'straight',
            },
          },
          {
            selector: 'edge',
            style: {
              'target-arrow-shape': 'triangle',
              'target-arrow-color': '#99ccdf',
              // 'arrow-opacity': 0.5,
            },
          },
        ]}
      />
    );
  },
  {id: 'ComputeGraphViz'}
);
